import { render, staticRenderFns } from "./InspectionsIcon.vue?vue&type=template&id=f296594e&"
import script from "./InspectionsIcon.vue?vue&type=script&lang=js&"
export * from "./InspectionsIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports